import adminApi from './adminAPI';

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api/v1'
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1');

export const adminUsuariosAPI = {
  async listar() {
    const { data } = await adminApi.get('/usuarios');
    return data.usuarios;
  },

  async criar({ email, nomeCompleto, password, tipo }) {
    const { data } = await adminApi.post('/usuarios', { email, nomeCompleto, password, tipo });
    return data;
  },

  async desativar(id) {
    await adminApi.delete(`/usuarios/${id}`);
  },

  async reativar(id) {
    await adminApi.patch(`/usuarios/${id}/reativar`);
  },

  // Retorna a senha temporária em texto puro — só existe nessa resposta,
  // uma vez (nunca é gravada em log nem reconsultável depois).
  async resetarSenha(id) {
    const { data } = await adminApi.patch(`/usuarios/${id}/resetar-senha`);
    return data.senha_temporaria;
  },

  async enviarFoto(id, arquivo) {
    const formData = new FormData();
    formData.append('foto', arquivo);
    const { data } = await adminApi.post(`/usuarios/${id}/foto`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return data.meta;
  },

  async removerFoto(id) {
    await adminApi.delete(`/usuarios/${id}/foto`);
  },

  async atualizarPerfil(id, { email, nomeCompleto }) {
    await adminApi.patch(`/usuarios/${id}`, { email, nomeCompleto });
  },

  async alterarSenhaPropria(id, { senhaAtual, novaSenha }) {
    await adminApi.patch(`/usuarios/${id}/senha`, { senhaAtual, novaSenha });
  },

  // Rota protegida por sessão (cookie httpOnly) — não passa por adminApi
  // porque é consumida direto por um <img src>, não por axios/fetch.
  fotoUrl(id) {
    return `${API_BASE_URL}/admin/usuarios/${id}/foto`;
  }
};

export default adminUsuariosAPI;
